import {
  parseObjectCookie,
  storeObjectAsCookie,
} from 'js/admin_user_tests/object_cookie';

type Test = string;
type Bucket = string;
type Overrides = Record<Test, Bucket>;

export const setTestOverrideInCookie = (test: Test, bucket: Bucket): void => {
  const overrides = getTestOverridesFromCookie();
  overrides[test] = bucket;
  setTestOverrides(overrides);
};

export const loseTestOverrideFromCookie = (test: Test): void => {
  const overrides = getTestOverridesFromCookie();
  delete overrides[test];
  setTestOverrides(overrides);
};

export const getTestOverrideFromCookie = (test: Test): Bucket => {
  const overrides = getTestOverridesFromCookie();
  return overrides[test];
};

export const getTestOverridesFromCookie = (): Overrides => {
  return parseObjectCookie('overridden_user_tests') as Overrides;
};

const setTestOverrides = (overrides: Overrides): void => {
  storeObjectAsCookie('overridden_user_tests', overrides);
};
